// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Debug: Log the environment variable (remove this after testing)
console.log('REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
console.log('API_BASE_URL:', API_BASE_URL);
console.log("process.env:", process.env);

export default API_BASE_URL;
